export default __webpack_public_path__ + "static/media/ki.fe08d473.jpg";